import { twMerge } from 'tailwind-merge';

import { WrapperProps } from './types';

export const Wrapper = ({ children, className }: WrapperProps) => {
  return (
    <div className={twMerge('mx-auto w-full max-w-7xl px-4', className)}>
      {children}
    </div>
  );
};
